import React, { useState } from "react";
import {
  TextField,
  IconButton,
  Button,
  Typography,
  InputAdornment,
  Grid,
  FormControl,
  FormLabel,
  useMediaQuery,
  Box,
  Paper,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import registerBgImg from "../../Assest/Images/registerBgImg.svg";
import registerSideImg from "../../Assest/Images/registerSideImg.svg";
import { useNavigate } from "react-router-dom";
import "./Register.css";
import Otp from "./Otp";
import { baseUrl, postData } from "../../BaseUrl";
import Routings from "../../Routings";
import CancelIcon from '@mui/icons-material/Cancel';
import useTranslations from "../Translations/useTranslations";

const Register = () => {
  const isTab = useMediaQuery("(max-width:912px)");
  const { translations, languageSelect } = useTranslations();
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordVisible1, setPasswordVisible1] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [focusedField, setFocusedField] = useState(null);
  const [formSubmit, setFormSubmit] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const togglePasswordVisibility1 = () => {
    setPasswordVisible1(!passwordVisible1);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const validateField = (fieldName, value) => {
    let error = "";

    switch (fieldName) {
      case "name":
        if (!value) {
          error = translations.nameRequired;
        }
        break;

      case "username":
        const usernameRegex = /^[a-zA-Z0-9]{4,}$/;
        if (!value) {
          error = translations.usernameRequired;
        } else if (!usernameRegex.test(value)) {
          error =
          translations.usernameError;
        }
        break;

      case "email":
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!value) {
          error = translations.emailRequired;
        } else if (!emailRegex.test(value)) {
          error = translations.validEmail;
        }
        break;

      case "phone":
        const phoneRegex = /^[0-9]{10}$/; // Adjust based on your phone number format
        if (!value) {
          error = translations.phoneRequired;
        } else if (!phoneRegex.test(value)) {
          error = translations.validPhone;
        }
        break;

      case "password":
        const passwordCriteria = {
          minLength: value.length >= 8,
          lowercase: /[a-z]/.test(value),
          uppercase: /[A-Z]/.test(value),
          number: /\d/.test(value),
          specialChar: /[@$!%*?&]/.test(value),
        };

        const unmetCriteria = Object.keys(passwordCriteria).filter(
          (key) => !passwordCriteria[key]
        );

        if (!value) {
          error = translations.passwordRequired;
        } else if (unmetCriteria.length > 0) {
          error = translations.passwordCriteriaError;
        }
        break;

      case "confirmPassword":
        if (!value) {
          error = translations.confirmPasswordRequired;
        } else if (value !== formValues.password) {
          error = translations.passwordMismatch;
        }
        break;

      default:
        break;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: error,
    }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
    setFocusedField(null); // Reset focused field on blur
  };

  const handleFocus = (e) => {
    setFocusedField(e.target.name); // Track which field is focused
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      fullName: formValues.name,
      username: formValues.username,
      email: formValues.email,
      mobileNo: formValues.phone,
      password: formValues.password,
      confirmPassword: formValues.confirmPassword,
    };

    console.log("formData", formData);
    console.log("formValues", formValues);
    const isValid = Object.values(errors).every((error) => error === "");
    if (isValid) {
      try {
        await postData(`${baseUrl}auth/register-user`, formData);
        setFormValues({
          name: "",
          username: "",
          email: "",
          phone: "",
          password: "",
          confirmPassword: "",
        });
        setFormSubmit(true);
      } catch (err) {
        console.error("Error:", err.message);
      }
    }
  };

  const styles = {
    container: {
      backgroundColor: "#F9F6FF",
      paddingTop: "8rem",
      background: isTab ? "#F9F6FF" : `url(${registerBgImg})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      minHeight: isTab ? "100vh" : "100%",
    },
    heading: {
      fontSize: "28px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "10px",
    },
    subheading: {
      fontSize: "14px",
      color: "rgba(58, 57, 57, 0.5)",
      marginBottom: "20px",
    },
    button: {
      background: "linear-gradient(90deg, #4A7BA8, #244C77)",
      color: "#fff",
      fontSize: languageSelect === "Tamil" ? "12px" :  "16px",
      textTransform: "none",
      padding: "5px 30px",
      borderRadius: "20px",
      marginTop: "2rem",
    },
    link: {
      color: "#2390FF",
      fontSize: "14px",
      textDecoration: "none",
      cursor: "pointer",
      marginTop: "10px",
    },
    formLable: {
      textAlign: "left",
      fontSize: languageSelect === "Tamil" ? "10px" : "16px"
    },
  };

  const passwordCriteria = {
    minLength: formValues.password.length >= 8,
    lowercase: /[a-z]/.test(formValues.password),
    uppercase: /[A-Z]/.test(formValues.password),
    number: /\d/.test(formValues.password),
    specialChar: /[@$!%*?&]/.test(formValues.password),
  };

  const isFormValid =
    Object.values(formValues).every((value) => value.trim() !== "") &&
    Object.values(errors).every((error) => error === "");

  return (
    <div style={styles.container}>
      <div className="register-container">
        <div className="register-side">
          {!isTab && (
            <img
              className="registerImg"
              src={registerSideImg}
              alt="registerSideImg"
              style={{
                width: "100%",
                objectFit: "cover",
                display: "block",
                marginTop: "-2rem",
              }}
            />
          )}
        </div>
        <div className="register-form" style={isTab ? {} : {maxHeight:"84vh", overflowY:"scroll"} }>
          <Typography style={styles.heading}>
            Cumming Tamil School{" "}
            <span style={{ color: "#244C77" }}>{translations.register}</span>
          </Typography>
          <Typography style={styles.subheading}>
          {translations.joinVibrantCommunity}
          </Typography>
          {formSubmit ? (
            <Otp setFormSubmit={setFormSubmit} />
          ) : (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={4} mt={1}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <FormLabel sx={styles.formLable}>
                    {translations.fullName}<span style={{ color: "red" }}>*</span>
                    </FormLabel>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder={translations.fullName}
                      variant="outlined"
                      name="name"
                      value={formValues.name}
                      onChange={handleInputChange}
                      onBlur={handleBlur} // Trigger validation on blur
                      onFocus={handleFocus} // Track focus
                      error={!!errors.name && focusedField !== "name"} // Show error only when field is blurred
                      helperText={focusedField !== "name" ? errors.name : ""}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <FormLabel sx={styles.formLable}>
                    {translations.username}<span style={{ color: "red" }}>*</span>
                    </FormLabel>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder={translations.username}
                      variant="outlined"
                      name="username"
                      value={formValues.username}
                      onChange={handleInputChange}
                      onBlur={handleBlur} // Trigger validation on blur
                      onFocus={handleFocus} // Track focus
                      error={!!errors.username && focusedField !== "username"} // Show error only when field is blurred
                      helperText={
                        focusedField !== "username" ? errors.username : ""
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <FormLabel sx={styles.formLable}>
                    {translations.email}<span style={{ color: "red" }}>*</span>
                    </FormLabel>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder={translations.email}
                      variant="outlined"
                      name="email"
                      value={formValues.email}
                      onChange={handleInputChange}
                      onBlur={handleBlur} // Trigger validation on blur
                      onFocus={handleFocus} // Track focus
                      error={!!errors.email && focusedField !== "email"}
                      helperText={focusedField !== "email" ? errors.email : ""}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <FormLabel sx={styles.formLable}>
                    {translations.phone}<span style={{ color: "red" }}>*</span>
                    </FormLabel>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder={translations.phone}
                      variant="outlined"
                      name="phone"
                      value={formValues.phone}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      onFocus={handleFocus}
                      error={!!errors.phone && focusedField !== "phone"}
                      helperText={focusedField !== "phone" ? errors.phone : ""}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} style={{ position: "relative" }}>
                  <FormControl fullWidth>
                    {focusedField === "password" && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          bottom: "100%",
                          left: 0,
                          zIndex: 10,
                          marginBottom: 1,
                          padding: 2,
                          backgroundColor: "#f9f9f9",
                          borderRadius: "12px",
                          width: "100%",
                          textAlign: "left",
                        }}
                      >
                        <Typography variant="body2" sx={{ marginBottom: 1 }}>
                        {translations.passwordCriteria.title}
                        </Typography>
                        {Object.entries(passwordCriteria).map(
                          ([key, isValid]) => (
                            <Box
                              key={key}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              {isValid ? (
                                <CheckCircleIcon color="success" />
                              ) : (
                                <CancelIcon color="error" />
                              )}
                              <Typography
                                variant="body2"
                                sx={{
                                  marginLeft: 1,
                                  color: isValid ? "green" : "red",
                                }}
                              >
                                {
                                  {
                                    minLength: translations.passwordCriteria.minLength,
                                    lowercase: translations.passwordCriteria.lowercase,
                                    uppercase: translations.passwordCriteria.uppercase,
                                    number: translations.passwordCriteria.number,
                                    specialChar:
                                    translations.passwordCriteria.specialChar,
                                  }[key]
                                }
                              </Typography>
                            </Box>
                          )
                        )}
                      </Paper>
                    )}
                    <FormLabel sx={styles.formLable}>
                    {translations.password}<span style={{ color: "red" }}>*</span>
                    </FormLabel>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder={translations.password}
                      variant="outlined"
                      name="password"
                      value={formValues.password}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      onFocus={handleFocus}
                      type={passwordVisible ? "text" : "password"}
                      error={!!errors.password && focusedField !== "password"}
                      helperText={
                        focusedField !== "password" ? errors.password : ""
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={togglePasswordVisibility}
                              edge="end"
                              style={{ color: "gray" }}
                            >
                              {passwordVisible ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <FormLabel sx={styles.formLable}>
                    {translations.confirmPassword}<span style={{ color: "red" }}>*</span>
                    </FormLabel>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder={translations.confirmPassword}
                      variant="outlined"
                      name="confirmPassword"
                      value={formValues.confirmPassword}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      onFocus={handleFocus}
                      type={passwordVisible1 ? "text" : "password"}
                      error={
                        !!errors.confirmPassword &&
                        focusedField !== "confirmPassword"
                      }
                      helperText={
                        focusedField !== "confirmPassword"
                          ? errors.confirmPassword
                          : ""
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={togglePasswordVisibility1}
                              edge="end"
                              style={{ color: "gray" }}
                            >
                              {passwordVisible1 ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Button
                type="submit"
                disabled={!isFormValid}
                variant="contained"
                style={styles.button}
              >
               {translations.verifyNow}
              </Button>
              <Typography
                variant="body2"
                align="center"
                style={{ marginTop: "10px" }}
              >
                {translations.alreadyHaveAccount}{" "}
                <span
                  onClick={() => {
                    navigate(Routings.LOGIN);
                  }}
                  style={styles.link}
                >
                  {translations.loginHeare}
                </span>
              </Typography>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Register;
